import { IMouseTrackingService, IPosition } from './mouse-tracking.interface';
import { injectable } from 'inversify';
import { Observable, Subject } from 'rxjs';

@injectable()
export class MouseTrackingService implements IMouseTrackingService {

    private startingPosition: IPosition;
    private _isTracked = false;
    private readonly position$ = new Subject<IPosition>();

    start(event: MouseEvent): void {
        this.startingPosition = {
            x: event.screenX,
            y: event.screenY,
        };
        this._isTracked = true;
    }

    stop(): void {
        this._isTracked = false;
    }

    move(event: MouseEvent): void {
        if (this._isTracked) {
            this.position$.next({
                x: event.screenX - this.startingPosition.x,
                y: event.screenY - this.startingPosition.y,
            });
        }
    }

    isTracked(): boolean {
        return this._isTracked;
    }

    asObservable(): Observable< IPosition> {
        return this.position$.asObservable();
    }
}
